import { i as y, b as g, S as s, a as m } from "./isArray-0d9c7aaa.mjs";
var a = "[object Symbol]";
function l(t) {
  return typeof t == "symbol" || y(t) && g(t) == a;
}
function S(t, r) {
  for (var n = -1, o = t == null ? 0 : t.length, i = Array(o); ++n < o; )
    i[n] = r(t[n], n, t);
  return i;
}
var c = 1 / 0, e = s ? s.prototype : void 0, b = e ? e.toString : void 0;
function f(t) {
  if (typeof t == "string")
    return t;
  if (m(t))
    return S(t, f) + "";
  if (l(t))
    return b ? b.call(t) : "";
  var r = t + "";
  return r == "0" && 1 / t == -c ? "-0" : r;
}
function u(t) {
  return t == null ? "" : f(t);
}
export {
  S as a,
  l as i,
  u as t
};
